<template>
  <div class="content-wrapper">
    <section class="content-header">
      <h1>
        Merchant
        <small>List of Merchant</small>
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li class="active">Merchant</li>
      </ol>
    </section>

    <section class="content">
      <div class="box">
        <div class="box-header with-border">
          <h3 class="box-title">Filter Merchants</h3>
          <div class="box-tools pull-right">
            <button type="button"
              class="btn btn-box-tool"
              data-widget="collapse">
              <i class="fa fa-minus"></i>
            </button>
          </div>
        </div>

        <div class="box-body" style="overflow: hidden;">
          <div class="row">
            <div class="col-12 col-md-3">
              <div class="form-group">
                <label for="name">
                  Name
                </label>

                <input type="text"
                  class="form-control"
                  id="name"
                  placeholder="Search by name here"
                  v-model="params.name"
                  @keyup="onInput">
              </div>
            </div>

            <div class="col-12 col-md-2">
              <div class="form-group">
                <label for="city">
                  City
                </label>

                <input type="text"
                  class="form-control"
                  id="city"
                  placeholder="Search by city here"
                  v-model="params.city"
                  @keyup="onInput">
              </div>
            </div>

            <div class="col-12 col-md-2">
              <div class="form-group">
                <label for="province">
                  Province
                </label>

                <input type="text"
                  class="form-control"
                  id="province"
                  placeholder="Search by province here"
                  v-model="params.province"
                  @keyup="onInput">
              </div>
            </div>

            <div class="col-12 col-md-2">
              <div class="form-group">
                <label for="country">
                  Country
                </label>

                <input type="text"
                  class="form-control"
                  id="country"
                  placeholder="Search by country here"
                  v-model="params.country"
                  @keyup="onInput">
              </div>
            </div>

            <div class="col-12 col-md-3">
              <div class="form-group">
                <label for="pic">
                  PIC
                </label>

                <input type="text"
                  class="form-control"
                  id="pic"
                  placeholder="Search by pic here"
                  v-model="params.pic"
                  @keyup="onInput">
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="box">
        <div class="box-header">
          <a class="btn btn-success pull-right"
            @click.prevent="add">
            Add New Merchant
          </a>
        </div>

        <div class="box-body">
          <table id="table" class="table table-bordered table-striped">
            <thead>
              <tr>
                <th class="text-center" style="min-width: 15rem">Merchant Name</th>
                <th class="text-center" style="min-width: 10rem">Merchant ID</th>
                <th class="text-center" style="min-width: 15rem">Address</th>
                <th class="text-center" style="min-width: 10rem">City</th>
                <th class="text-center" style="min-width: 10rem">Province</th>
                <th class="text-center" style="min-width: 10rem">Country</th>
                <th class="text-center" style="min-width: 10rem">Zip Code</th>
                <th class="text-center" style="min-width: 13rem">Phone Number</th>
                <th class="text-center" style="min-width: 10rem">Email</th>
                <th class="text-center" style="min-width: 10rem">PIC</th>
                <!-- <th>Contact Person</th> -->
                <th class="text-center" >Action(s)</th>
              </tr>
            </thead>

            <tbody v-if="!merchants" key="empty">
              <tr>
                <td colspan="13">
                  <h4>Result not found</h4>
                </td>
              </tr>
            </tbody>

            <tbody v-else key="data">
              <tr v-if="isLoading">
                <td colspan="13">
                  <strong>Loading...</strong>
                </td>
              </tr>
              <tr v-if="!isLoading && error" key="empty">
                <td colspan="5">
                  <strong>Data failed to load</strong>
                </td>
              </tr>
              <tr v-else v-for="merchant in merchants" :key="merchant.id">
                <td>{{ merchant.name }}</td>
                <td style="text-align: center">
                  <span 
                    v-if="merchant.code"
                    class="badge badge-primary pointer">
                    {{ merchant.code }}
                  </span>
                  <span v-else>-</span>
                </td>
                <td>{{ merchant.address }}</td>
                <td>{{ merchant.city }}</td>
                <td>{{ merchant.province }}</td>
                <td>{{ merchant.country }}</td>
                <td>{{ merchant.zip_code }}</td>
                <td>{{ merchant.phone }}</td>
                <td>{{ merchant.email }}</td>
                <td>{{ merchant.pic }}</td>
                <!-- <td>{{ merchant.contact_person }}</td> -->
                <td style="min-width: 10rem;">
                  <a class="btn btn-primary btn-xs" @click.prevent="edit(merchant.id)">Edit</a>
                  <a class="btn btn-danger btn-xs" @click.prevent="remove(merchant)">Delete</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="box-footer">
          <Pagination
            :pagination="pagination"
            @goto-page="changePage" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import Common from '@/mixins/Common';
import Pagination from '@/components/modules/common/Pagination';

export default {
  name: 'MerchantIndex',

  mixins: [Common],

  components: {
    Pagination,
  },

  data() {
    return {
      merchants: [],
      pagination: {},
      isLoading: false,
      error: null,

      params: {
        page: null,
        name: null,
        city: null,
        country: null,
        province: null,
        pic: null,
      },
    };
  },

  methods: {
    fetch(page = null) {
      this.isLoading = true;
      if (page) this.params.page = page || null;

      const params = this.params;

      this.axios.get('/merchants', { params })
        .then((response) => {
          const { data, meta } = response.data;

          if (!data && (meta.pagination.current_page > meta.pagination.total_pages)) {
            this.merchants = null;
            this.pagination = {};
            return;
          }

          this.merchants = data;
          this.pagination = meta.pagination;
        })
        .catch((error) => {
          console.log('Fetch product error', error);

            if (error.response) {
              this.error = error.response.data.errors;
            }

            if (error) {
              this.$swal({
                title: 'Failed',
                text: 'Failed to fetch Merchants data',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#666',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Try again',
              }).then((result) => {
                if (result.value) {
                  this.fetchProduct();
                }
              });
            }
        })
        .finally(() => {
          this.isLoading = false;
        });

      if (page) {
        window.history.pushState(`Merchant page: ${page}`, null, `/merchant?page=${page}`);
      }
    },

    onInput: debounce(function debouncedInput() {
      this.fetch();
    }, 500),

    changePage(page) {
      this.fetch(page);
    },

    add() {
      this.$router.push({
        name: 'merchant-create',
      });
    },

    edit(id) {
      this.$router.push({
        name: 'merchant-edit',
        params: {
          id,
        },
      });
    },

    delete(merchant) {
      this.axios.delete(`/merchants/${merchant.id}`)
        .then(() => {
          this.fetch();

          this.$swal({
            title: 'Deleted',
            text: `${merchant.name} has been deleted.`,
            type: 'success',
            timer: 2000,
          });
        });
    },

    remove(merchant) {
      this.$swal({
        title: 'Deleting Merchant',
        text: `Are you sure you want to delete ${merchant.name}?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it',
      })
      .then((result) => {
        if (result.value) {
          this.delete(merchant);
        } else {
          this.$swal({
            title: 'Cancelled',
            type: 'info',
            timer: 2000,
          });
        }

        if (result.dismiss === 'overlay' || result.dismiss === 'cancel') {
          this.$swal({
            title: 'Cancelled',
            type: 'info',
            timer: 2000,
          });
        }
      });
    },

    setQuery() {
      return new Promise((resolve) => {
        this.params.name = this.$route.query.name || null;
        this.params.page = this.$route.query.page || null;
        this.params.city = this.$route.query.city || null;
        this.params.country = this.$route.query.country || null;
        this.params.province = this.$route.query.province || null;
        this.params.pic = this.$route.query.pic || null;
        resolve();
      });
    },
  },

  async created() {
    await this.setQuery();
    this.fetch();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/modules/merchant/Index.vue